module.exports = __webpack_public_path__ + "static/media/LogoBusinessReportsTransBlue.f10d4709.png";